import {getBeneMcCAmishSwitchData, getParticipantBeneficiaryData} from "../redux/profile/slice";

export default {
  DEV: {
    getPlansData: "/rps/participant-profile/plans",
    getPersonalInformationData:"/rps/participant-profile/participant",
    getPhoneNumber: "/rps/participant-contact/participant-phone-number",
    updatePhoneNumber: "/rps/participant-contact/participant-phone-number",
    savePhoneNumber: "/rps/participant-contact/participant-phone-number",
    getActivationCode: "/rps/participant-contact/activation-otp",
    submitActivationCode: "/rps/participant-contact/activate-mobile-phone",
    getEmailAddress: "/rps/participant-contact/email",
    updateEmailAddress: "/rps/participant-contact/email-address",
    getPlanProfileOlaMessageData: "/rps/plan-profile/ola-message",
    getSempraActivePlanNameOlaMsg:"/rps/plan-profile/ola-message",
    getSempraTerminatedPlanNameOlaMsg:"/rps/plan-profile/ola-message",
    getParticipantTerminateOlaMessageData: "/rps/plan-profile/ola-message",
    getPlansInfoData: "/rps/plan-profile/plans-info?channel=OLA",
    getPlansRulesData: "/rps/plan-profile/plans-rules?channel=OLA",
    getParticipantBeneficiaryData: "/rps/bene-service/partic-beneficiary/secure/participant-beneficiary",
    getDefinedBenefitParticipantBeneficiariesData: "/rps/bene-service/partic-beneficiary/secure/defined-benefit-participant-beneficiaries",
    getClientProfile: "/rps/participant-profile/ubr/profile/search",
    saveOrUpdateClientProfile: "/rps/participant-profile/ubr/profile",
    getReferenceTypeValues: "/rps-reference-service/service/plan-client/reference-type-values/type-id",
    getRixScenario: "/retirement-income-ui/service/ri-scenario",
    getCompensations: "/rps/participant-compensation/compensations",
    updateCompensations: "/rps/participant-compensation/compensations",
    saveRixSalaryPayFrequency: "/rps/participant-profile/rix-salary-payfrequency",
    saveOrUpdateRiSimulation: "/retirement-income-ui/service/ri-simulation?simulationType=CURRENT_WANT&refreshFromMStar=true",
    getBeneMcCAmishSwitchData: "/rps/plan-profile/ola-message",
    getProfileMfaData: "/rps/participant-profile/auth/profile/mfa",
    setAlwaysChallengeMfa: "/rps/participant-profile/auth/profile/mfa/always-challenge",
    getParticipantConsents: "/rps/participant-profile/consent",
    getTaxRateBrackets: "/rps-reference-service/service/irs-client/tax-brackets",
    getOtherRetirementPlansData:"/rps/workplace/ui/other-retirement-plans",
    showOrHideOtherRetirementPlans:"/rps/workplace/ui/workspace-preferences",
    getServiceStatus: "/rps/participant-profile/service-status",
    updateServiceStatus: "/rps/participant-profile/service-status",
    deleteServiceStatus: "/rps/participant-profile/service-status",
    getPlanProducts: "/rps/plan-profile/filtered-plan-products-by-plan",
    getServiceProducts: "/rps/participant-profile/service-products",
    updateServiceProducts: "/rps/participant-profile/service-products",
    savePreferencesAndSubscriptionConsents: "/rps/participant-profile/add-consents"
  },
  STAGE: {
    getPlansData: "/rps/participant-profile/plans",
    getPersonalInformationData:"/rps/participant-profile/participant",
    getPhoneNumber: "/rps/participant-contact/participant-phone-number",
    updatePhoneNumber: "/rps/participant-contact/participant-phone-number",
    savePhoneNumber: "/rps/participant-contact/participant-phone-number",
    getActivationCode: "/rps/participant-contact/activation-otp",
    submitActivationCode: "/rps/participant-contact/activate-mobile-phone",
    getEmailAddress: "/rps/participant-contact/email",
    updateEmailAddress: "/rps/participant-contact/email-address",
    getPlanProfileOlaMessageData: "/rps/plan-profile/ola-message",
    getParticipantTerminateOlaMessageData: "/rps/plan-profile/ola-message",
    getSempraActivePlanNameOlaMsg:"/rps/plan-profile/ola-message",
    getSempraTerminatedPlanNameOlaMsg:"/rps/plan-profile/ola-message",
    getPlansInfoData: "/rps/plan-profile/plans-info?channel=OLA",
    getPlansRulesData: "/rps/plan-profile/plans-rules?channel=OLA",
    getParticipantBeneficiaryData: "/rps/bene-service/partic-beneficiary/secure/participant-beneficiary",
    getDefinedBenefitParticipantBeneficiariesData: "/rps/bene-service/partic-beneficiary/secure/defined-benefit-participant-beneficiaries",
    getClientProfile: "/rps/participant-profile/ubr/profile/search",
    saveOrUpdateClientProfile: "/rps/participant-profile/ubr/profile",
    getReferenceTypeValues: "/rps-reference-service/service/plan-client/reference-type-values/type-id",
    getRixScenario: "/retirement-income-ui/service/ri-scenario",
    getCompensations: "/rps/participant-compensation/compensations",
    updateCompensations: "/rps/participant-compensation/compensations",
    saveRixSalaryPayFrequency: "/rps/participant-profile/rix-salary-payfrequency",
    saveOrUpdateRiSimulation: "/retirement-income-ui/service/ri-simulation?simulationType=CURRENT_WANT&refreshFromMStar=true",
    getBeneMcCAmishSwitchData: "/rps/plan-profile/ola-message",
    getProfileMfaData: "/rps/participant-profile/auth/profile/mfa",
    setAlwaysChallengeMfa: "/rps/participant-profile/auth/profile/mfa/always-challenge",
    getParticipantConsents: "/rps/participant-profile/consent",
    getTaxRateBrackets: "/rps-reference-service/service/irs-client/tax-brackets",
    getOtherRetirementPlansData:"/rps/workplace/ui/other-retirement-plans",
    showOrHideOtherRetirementPlans:"/rps/workplace/ui/workspace-preferences",
    getServiceStatus: "/rps/participant-profile/service-status",
    updateServiceStatus: "/rps/participant-profile/service-status",
    deleteServiceStatus: "/rps/participant-profile/service-status",
    getPlanProducts: "/rps/plan-profile/filtered-plan-products-by-plan",
    getServiceProducts: "/rps/participant-profile/service-products",
    updateServiceProducts: "/rps/participant-profile/service-products",
    savePreferencesAndSubscriptionConsents: "/rps/participant-profile/add-consents"
  },
  PROD: {
    getPlansData: "/rps/participant-profile/plans",
    getPersonalInformationData:"/rps/participant-profile/participant",
    getPhoneNumber: "/rps/participant-contact/participant-phone-number",
    updatePhoneNumber: "/rps/participant-contact/participant-phone-number",
    savePhoneNumber: "/rps/participant-contact/participant-phone-number",
    getActivationCode: "/rps/participant-contact/activation-otp",
    submitActivationCode: "/rps/participant-contact/activate-mobile-phone",
    getEmailAddress: "/rps/participant-contact/email",
    getPlanProfileOlaMessageData: "/rps/plan-profile/ola-message",
    getSempraActivePlanNameOlaMsg:"/rps/plan-profile/ola-message",
    getSempraTerminatedPlanNameOlaMsg:"/rps/plan-profile/ola-message",
    getParticipantTerminateOlaMessageData: "/rps/plan-profile/ola-message",
    updateEmailAddress: "/rps/participant-contact/email-address",
    getClientProfile: "/rps/participant-profile/ubr/profile/search",
    getPlansInfoData: "/rps/plan-profile/plans-info?channel=OLA",
    getPlansRulesData: "/rps/plan-profile/plans-rules?channel=OLA",
    getParticipantBeneficiaryData: "/rps/bene-service/partic-beneficiary/secure/participant-beneficiary",
    getDefinedBenefitParticipantBeneficiariesData: "/rps/bene-service/partic-beneficiary/secure/defined-benefit-participant-beneficiaries",
    saveOrUpdateClientProfile: "/rps/participant-profile/ubr/profile",
    getReferenceTypeValues: "/rps-reference-service/service/plan-client/reference-type-values/type-id",
    getRixScenario: "/retirement-income-ui/service/ri-scenario",
    getCompensations: "/rps/participant-compensation/compensations",
    updateCompensations: "/rps/participant-compensation/compensations",
    saveRixSalaryPayFrequency: "/rps/participant-profile/rix-salary-payfrequency",
    saveOrUpdateRiSimulation: "/retirement-income-ui/service/ri-simulation?simulationType=CURRENT_WANT&refreshFromMStar=true",
    getBeneMcCAmishSwitchData: "/rps/plan-profile/ola-message",
    getProfileMfaData: "/rps/participant-profile/auth/profile/mfa",
    setAlwaysChallengeMfa: "/rps/participant-profile/auth/profile/mfa/always-challenge",
    getParticipantConsents: "/rps/participant-profile/consent",
    getTaxRateBrackets: "/rps-reference-service/service/irs-client/tax-brackets",
    getOtherRetirementPlansData:"/rps/workplace/ui/other-retirement-plans",
    showOrHideOtherRetirementPlans:"/rps/workplace/ui/workspace-preferences",
    getServiceStatus: "/rps/participant-profile/service-status",
    updateServiceStatus: "/rps/participant-profile/service-status",
    deleteServiceStatus: "/rps/participant-profile/service-status",
    getPlanProducts: "/rps/plan-profile/filtered-plan-products-by-plan",
    getServiceProducts: "/rps/participant-profile/service-products",
    updateServiceProducts: "/rps/participant-profile/service-products",
    savePreferencesAndSubscriptionConsents: "/rps/participant-profile/add-consents"
  },
  SANDBOX: {
    getPersonalInformationData:"/rps/participant-profile/participant"
  },
  LOCALHOST: {
    getPlansData: "getPlansData",
    getPersonalInformationData:"getPersonalInformationData",
    getPhoneNumber: "getPhoneNumber",
    updatePhoneNumber: "postPhoneNumber",
    savePhoneNumber:"putPhoneNumber",
    getActivationCode: "getActivationCode",
    submitActivationCode: "submitActivationCode",
    getEmailAddress: "getEmailAddress",
    updateEmailAddress: "updateEmailAddress",
    getPlanProfileOlaMessageData: "getPlanProfileOlaMessageData",
    getParticipantTerminateOlaMessageData: "getParticipantTerminateOlaMessageData",
    getSempraActivePlanNameOlaMsg:"getSempraActivePlanNameOlaMsg",
    getSempraTerminatedPlanNameOlaMsg:"getSempraTerminatedPlanNameOlaMsg",
    getClientProfile: "getClientProfile",
    getPlansInfoData: "getPlansInfoData",
    getPlansRulesData: "getPlansRulesData",
    getParticipantBeneficiaryData: "getParticipantBeneficiaryData",
    getDefinedBenefitParticipantBeneficiariesData: "getDefinedBenefitParticipantBeneficiariesData",
    getBeneMcCAmishSwitchData: "getBeneMcCAmishSwitchData",
    getProfileMfaData: "getProfileMfaData",
    setAlwaysChallengeMfa: "setAlwaysChallengeMfa",
    getParticipantConsents: "getParticipantConsents",
    getTaxRateBrackets: "getTaxRateBrackets",
    getReferenceTypeValues: "getReferenceTypeValues",
    saveOrUpdateClientProfile: "postClientProfile",
    getRixScenario: "getRixScenario",
    getCompensations: "getCompensations",
    updateCompensations: "updateCompensations",
    saveRixSalaryPayFrequency: "saveRixSalaryPayFrequency",
    saveOrUpdateRiSimulation: "saveOrUpdateRiSimulation",
    getOtherRetirementPlansData: "getOtherRetirementPlansData",
    showOrHideOtherRetirementPlans:"showOrHideOtherRetirementPlans",
    getServiceStatus: "getServiceStatus",
    updateServiceStatus: "updateServiceStatus",
    deleteServiceStatus: "deleteServiceStatus",
    getPlanProducts: "getPlanProducts",
    getServiceProducts: "getServiceProducts",
    updateServiceProducts: "updateServiceProducts",
    savePreferencesAndSubscriptionConsents: "savePreferencesAndSubscriptionConsents"
  },
};
